// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__rN2+V","consentGrid":"CookieModal_consentGrid__dqnWl","buttonGrid":"CookieModal_buttonGrid__IPTUF","consentModal":"CookieModal_consentModal__MK2Ts"};